import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator";

function n(n) {
  if ("function" != typeof n) throw new Error("Expected a callable value, but got " + typeof n);
  return n;
}

function t(n) {
  if (null == n) throw new Error("Expected non nullable, but got " + typeof n);
}

var r = function r() {},
    o = function o(n) {
  return n;
};

function e(n) {}

function u(n) {}

function i() {}

function f(n) {
  for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  return "function" == typeof n ? n.apply(void 0, t) : n;
}

var c = {
  __proto__: null,
  range: f
};

function l(n) {
  return null != n;
}

function a(n) {
  return l(n) ? "Some(".concat(typeof n, ")") : "None";
}

function p(n) {
  return l(n) ? "Some" : "None";
}

function s(n, t) {
  if ("function" == typeof t) return l(n) ? t(n) : null;
  if ("object" != typeof t) throw new Error("The second argument only allows function or object but got: " + typeof t);
  var r = p(n);
  if (!(r in t)) throw new Error("The object doesn't have bind to ".concat(a(n), " pattern"));
  return f(t[r], n);
}

var h = {
  __proto__: null,
  of: function of(n) {
    return f(n);
  },
  ofUnsafe: function ofUnsafe(n) {
    try {
      return n();
    } catch (n) {
      return null;
    }
  },
  isSome: l,
  isNone: function isNone(n) {
    return null == n;
  },
  toString: a,
  match: p,
  map: s,
  getExn: function getExn(n, t) {
    return s(n, {
      Some: function Some(n) {
        return n;
      },
      None: function None() {
        var n;
        throw null != (n = null == t ? void 0 : t()) ? n : new Error("You tried to get T of Option<T>, ut T is None");
      }
    });
  }
};

function y(n) {
  return !!n;
}

var E = {
  __proto__: null,
  isTruthy: y,
  isFalsy: function isFalsy(n) {
    return !n;
  },
  of: function of(n) {
    return n;
  },
  map: function map(n, t) {
    return y(n) ? f(t, n) : n;
  }
},
    w = {
  __proto__: null
};

var _ = Symbol("ok"),
    b = Symbol("err");

function g(n) {
  return [_, n];
}

function m(n) {
  return [b, n];
}

function d(n) {
  return v(n) ? "Ok" : "Err";
}

function T(n) {
  return "".concat(d(n), "(").concat(typeof n, ")");
}

function v(n) {
  return n[0] === _;
}

function x(n) {
  return n[0] === b;
}

var S = {
  __proto__: null,
  ok: g,
  err: m,
  ofUnsafe: function ofUnsafe(n) {
    try {
      return g(n());
    } catch (n) {
      return m(n);
    }
  },
  ofPromise: function () {
    var _ofPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.t0 = g;
              _context.next = 4;
              return f(n);

            case 4:
              _context.t1 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1));

            case 8:
              _context.prev = 8;
              _context.t2 = _context["catch"](0);
              return _context.abrupt("return", m(_context.t2));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    function ofPromise(_x) {
      return _ofPromise.apply(this, arguments);
    }

    return ofPromise;
  }(),
  match: d,
  toString: T,
  isOk: v,
  isErr: x,
  getExn: function getExn(n) {
    if (v(n)) return n[1];
    throw new Error("Expected Ok<T>, but got: ".concat(T(n)));
  },
  getWithDefault: function getWithDefault(n, t) {
    return v(n) ? n[1] : t;
  },
  getErrExn: function getErrExn(n) {
    if (x(n)) return n[1];
    throw new Error("Expected Err<T>, but got: ".concat(T(n)));
  },
  getErrWithDefault: function getErrWithDefault(n, t) {
    return x(n) ? n[1] : t;
  },
  map: function map(n, t) {
    if ("function" == typeof t) return v(n) ? g(t(n[1])) : n;
    if ("object" != typeof t) throw new Error("The second argument only allows function or object but got: " + typeof t);
    var r = d(n);
    if (!(r in t)) throw new Error("The object doesn't have bind to ".concat(r, " pattern"));
    return v(n) ? g(f(t.Ok, n[1])) : m(f(t.Err, n[1]));
  }
};
export { E as Condition, c as Fn, h as Option, S as Result, w as Tuple, n as callable, u as expectAssignable, i as expectEquals, e as expectType, o as ident, r as noop, t as required };